import React, { PropsWithChildren, ReactNode } from "react";

import { Link } from "react-router-dom";

import { Flex, Stack, Button } from "@chakra-ui/react";

import useStore from "../../../store";
import useTranslations from "../../../hooks/useTranslations";

import { NavigationHeader } from "./NavigationHeader";

import ReportSaveIndicator from "../components/ReportSaveIndicator";
import ReportProgress from "../components/ReportProgress";

const ReportLeaveButton = () => {
  const t = useTranslations();

  const [, reportState] = useStore((state) => state.report.viewedReportState);
  const currentStep = useStore((state) => state.report.currentStep);
  const setCurrentStep = useStore((state) => state.report.setCurrentStep);

  if (reportState !== "edit" || currentStep !== "report")
    return (
      <Button as={Link} to="/" variant="ghost">
        {t("reports.edit.quit")}
      </Button>
    );
  return (
    <Button onClick={() => setCurrentStep("leaving")} variant="ghost" to="">
      {t("reports.edit.quit")}
    </Button>
  );
};

type ReportLayoutProps = PropsWithChildren<{
  subHeader?: ReactNode;
  canLeave?: boolean;
}>;

const ReportLayout: React.FC<ReportLayoutProps> = ({
  subHeader,
  canLeave = true,
  children,
}) => {
  return (
    <Flex direction="column" minHeight="100vh" className="no-print">
      <NavigationHeader
        subHeader={subHeader}
        isBranded
        rightElement={
          <Stack direction="row" spacing="5" alignItems="center">
            <ReportSaveIndicator />
            {canLeave && <ReportLeaveButton />}
          </Stack>
        }
      >
        <ReportProgress />
      </NavigationHeader>
      <Flex bgColor="primary.50" direction="column" flexGrow={1}>
        {children}
      </Flex>
    </Flex>
  );
};

export default ReportLayout;
